import { MODAL_CLOSE_BUTTON_TEST_ID } from 'components/Modal.const';

export const MENU_ITEM_MODAL_TEST_ID = {
  root: 'modifier-modal',
  submitButton: 'add-to-order-button',
  itemSubtotal: 'item-subtotal',
  closeButton: MODAL_CLOSE_BUTTON_TEST_ID,
  radioButton: 'radio-button',
  checkbox: 'checkbox',
  specialInstructions: 'special-instructions',
  specialInstructionsText: 'special-instructions-text',
  closedBanner: 'modal-closed-banner',
  modifierName: 'modifier-name',
  recipientFullname: 'recipient-fullname',
  recipientEmail: 'recipient-email',
  note: 'note',
  image: 'image-test-id',
  bannerMessage: 'banner-message',
  unavailable: 'Unavailable'
};
